import { divider_custom_styles_default } from "./chunk.FA6V2WD6.js";
import { divider_styles_default } from "./chunk.FSZIE7IO.js";
import { watch } from "./chunk.BVZQ6QSY.js";
import { component_styles_default } from "./chunk.NLYVOJGK.js";
import { SynergyElement } from "./chunk.AFZ5JDGZ.js";
import { __decorateClass } from "./chunk.Z4XV3SMG.js";

// src/components/divider/divider.component.ts
import { property } from "lit/decorators.js";
var SynDivider = /*#__PURE__*/(() => {
  let SynDivider = class extends SynergyElement {
    constructor() {
      super(...arguments);
      this.vertical = false;
    }
    connectedCallback() {
      super.connectedCallback();
      this.setAttribute("role", "separator");
    }
    handleVerticalChange() {
      this.setAttribute("aria-orientation", this.vertical ? "vertical" : "horizontal");
    }
  };
  SynDivider.styles = [component_styles_default, divider_styles_default, divider_custom_styles_default];
  return SynDivider;
})();
__decorateClass([property({
  type: Boolean,
  reflect: true
})], SynDivider.prototype, "vertical", 2);
__decorateClass([watch("vertical")], SynDivider.prototype, "handleVerticalChange", 1);
export { SynDivider };
